import { useEffect } from 'react'
import { pendingSelector } from 'api/selectors'
import { withTranslatedMeta } from 'i18n/utils'
import { withRouter } from 'i18n/utils'
import { activateAccount } from 'activation/actions'
import { toggleAuthVisible } from 'header/actions'
import ActivationViewComponent from 'activation/components/ActivationView'

const ActivationView = ({ location, activateAccount, pending, toggleAuthVisible }) => {
    const query = new URLSearchParams(location.search)
    const activationCode = query.get('activation_code')
    const userId = query.get('user_id')

    const activateAccountError = pending.activateAccount instanceof Error ? pending.activateAccount.message : ''
    const isLoading = !!pending.activateAccount && !activateAccountError

    useEffect(() => {
        activateAccount(userId, activationCode)
    }, [])

    return <ActivationViewComponent error={activateAccountError} isLoading={isLoading} onClick={toggleAuthVisible} />
}

export default compose(
    withTranslatedMeta('activation.title'),
    withRouter,
    connect(
        createStructuredSelector({
            pending: pendingSelector,
        }),
        {
            activateAccount,
            toggleAuthVisible,
        }
    )
)(ActivationView)
